import type { Interlingual } from "~/i18n/types"
import type { Design } from "~/utils/finance/design-types"

export const REBATES: [keyof Design, keyof Design, Interlingual][] = [
  [`homeownerRebate`, `homeownerRebateAmount`, `homeownerRebate`],
  [`roofWorkRebate`, `roofWorkRebateAmount`, `roofWorkRebate`],
  [
    `energyEfficiencyKitRebate`,
    `energyEfficiencyKitRebateAmount`,
    `energyEfficiencyKitRebate`,
  ],
  [`treeTrimmingRebate`, `treeTrimmingRebateAmount`, `treeTrimmingRebate`],
]
